var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECT",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750.01532 550.00008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n      fill: #7c7c7c;\n      }\n\n      .cls-2 {\n      fill: #c6c6c6;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "light",
    className: "cls-1",
    x: 50.00765,
    y: 175,
    width: 650,
    height: 300,
    rx: 25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dark"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M770.25,410.5A25,25,0,0,0,750,400H50a25.2079,25.2079,0,0,0-23.75,33l75,225A24.9999,24.9999,0,0,0,125,675H675a24.9999,24.9999,0,0,0,23.75-17l75-225A24.99992,24.99992,0,0,0,770.25,410.5ZM250,600H200a25,25,0,0,1,0-50h50a25,25,0,0,1,0,50Z",
    transform: "translate(-24.99235 -125)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M675.5,275a75,75,0,0,0-75-75H314l-42.75-63.75A25.00006,25.00006,0,0,0,250.5,125h-50a75,75,0,0,0-75,75V300h550Z",
    transform: "translate(-24.99235 -125)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorks);
export default __webpack_public_path__ + "static/media/works.b3916ea7.svg";
export { ForwardRef as ReactComponent };